<template>
  <section class="home-cta" :style="ctaStyle">
    <div class="container">
      <div class="cta-icons reveal">
        <span class="cta-icon">人</span>
        <span class="cta-icon">证</span>
        <span class="cta-icon">链</span>
        <span class="cta-icon">网</span>
      </div>
      <h2 class="cta-title reveal">
        赚钱跑道已经搭好，<br>就差与您分这杯<span class="gold-text">新基建的时代羹</span>
      </h2>
      <p class="section-copy reveal" style="color:#c3cee4">
        注册免费，不需要先掏钱。选择你想扎根的生态，现在开始。
      </p>
      <div class="cta-ecos reveal">
        <button
          v-for="eco in ecosystems"
          :key="eco.slug"
          class="card cta-eco"
          @click="$router.push(`/register?eco=${eco.slug}`)"
        >
          <div style="color:var(--amber)">✓</div>
          <div style="margin-top:5px;font-weight:700">注册{{ eco.name }}</div>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HomeCTA',
  props: {
    image: { type: String, default: '' }
  },
  computed: {
    ...mapState('ecosystem', ['ecosystems']),
    ctaStyle() {
      return { backgroundImage: 'url(' + this.image + ')' };
    }
  }
};
</script>

<style lang="less" scoped>
.home-cta {
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 96px 0;
  background-size: cover;
  background-position: center;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, #050b18, rgba(5, 11, 24, 0.68), #050b18);
  }

  .container {
    position: relative;
    z-index: 2;
  }
}

.cta-icons {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 27px;
}

.cta-icon {
  width: 48px;
  height: 48px;
  border: 1px solid rgba(255, 213, 106, 0.25);
  border-radius: 13px;
  background: rgba(255, 213, 106, 0.09);
  display: grid;
  place-items: center;
  color: var(--amber);
  position: relative;
  animation: ctaFloat 3.2s ease-in-out infinite;
  transition: all 0.3s;
}

.cta-icon:nth-child(2) { animation-delay: 0.5s; }
.cta-icon:nth-child(3) { animation-delay: 1s; }
.cta-icon:nth-child(4) { animation-delay: 1.5s; }

@keyframes ctaFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

.cta-title {
  font-size: 46px;
  line-height: 1.25;
}

.cta-ecos {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin: 34px auto 0;
  max-width: 900px;
}

.cta-eco {
  padding: 18px 12px;
  cursor: pointer;
  background: transparent;
  color: inherit;
  text-align: center;

  &:hover {
    border-color: rgba(255, 213, 106, 0.5);
    background: rgba(255, 213, 106, 0.08);
    transform: translateY(-5px) !important;
    box-shadow: 0 16px 36px rgba(0, 0, 0, 0.32);
  }
}

@media (max-width: 760px) {
  .cta-ecos {
    grid-template-columns: 1fr;
  }
}
</style>
